module.exports = __webpack_public_path__ + "img/btn-delete.d424cfee.svg";